import { SLLayer } from './../../../model/sl-layer';
import { AnyHandler } from './../../../types/@types/sl-v-types';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomSymbolDialogService {
  public request$: Subject<any> = new Subject();
  constructor() { }

  public Show(handler: AnyHandler) {
    this.request$.next({ handler: (handler) });
  }
  public Edit(symbol: string, handler: AnyHandler) {
    this.request$.next({ handler: (handler), symbol: symbol })
  }
}
